import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'

import { ErrorBoundary, withError } from '../../shared/components/error-boundary';
import ABTest from '../../abtest/components/abtest';
import NavArrow from '../../shared/components/nav-arrow';
import { setCarouselHeight } from '../../shared/components/carousel';
import { addMultipleToCart } from '../../utility/utility-actions';
import Prechecked from './prechecked';
import TabsXsellModal from './tabs-xsell-modal';
import TabsXsellBundleTestModal from './tabs-xsell-modal-bundle-test';
import XSELL_TEMPLATES from '../xsell-templates';
import XSellProductItem from './xsell-product';
import { Helpers } from '../../core/src/helpers';
import {getProductClickMetrics} from '../../metrics/metrics-helpers';

import '../../product/css/purchase-button.less';

const TwoUpV2 = loadable(() => import('./two-up-v2'));
const TabsXsellModalV2 = loadable(() => import('./tabs-xsell-v2'));

class XSellModal extends React.Component {

    static propTypes = {
      xSellProducts: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            addedProducts: [],
            quantities: [],
            busy: false,
            instantInkClicked: false,
        }

        this.carousel = React.createRef();
        this.addProduct = this.addProduct.bind(this);
        this.removeProduct = this.removeProduct.bind(this);
        this.proceed = this.proceed.bind(this);
    }

    componentDidMount(){
        const { template, xSellProducts } = this.props;
        if(template === XSELL_TEMPLATES.PRECHECKED || template === XSELL_TEMPLATES.TWOUPV2){
            this.addProduct(xSellProducts.productGroup.productsList.slice(0,2));          
        }
    }

    setHTML(html) {
        let el = document.createElement('div');
        el.innerHTML = html;
        return el.innerText;
    }

    handleInstantInkClick = () => {
        this.setState({ instantInkClicked: !this.state.instantInkClicked })
    }

    proceed(xsellType, ctaMetrics) {
        const blockFlyout = true;
        const {product = {}, template, crtUrl } = this.props;
        const { sku: baseSKU } = product;
        const setHTML = this.setHTML;
        let xsellMethod;
        if (template === XSELL_TEMPLATES.PRECHECKED || template === XSELL_TEMPLATES.TWOUPV2) {
            xsellMethod = '2up-ink';
        } else {
            xsellMethod = xsellType;
        }
        if(this.state.addedProducts.length > 0) {
            this.props.addToCart(this.state.addedProducts, this.state.quantities, blockFlyout, {baseSKU}, baseSKU, xsellMethod, ctaMetrics).then(()=>{
                /*set time out so that tracking can fire before going to the next page*/
                setTimeout(function() {
                    window.location = setHTML(crtUrl)
                }, 400);
            });
        } else {
            window.location = setHTML(crtUrl)
        }
    }

    addProduct(product){
        let addedProducts = product.constructor === Array ? [...this.state.addedProducts, ...product] : [...this.state.addedProducts, product];
        let quantities = product.constructor === Array ? [...this.state.quantities, ...[1,1]] : [...this.state.quantities, 1];
        this.setState({addedProducts, quantities});
    }

    removeProduct(product){
        let addedProducts = this.state.addedProducts;
        let quantities = this.state.quantities;
        quantities.splice( addedProducts.indexOf(product), 1 );
        addedProducts.splice( addedProducts.indexOf(product), 1 );
        this.setState({addedProducts, quantities});
    }

    xSellProductList(xSellProducts, enableCarousel, disableRemove, twoUpVersion) {
        const { template='' } = this.props;
        const isV2 = template === XSELL_TEMPLATES.TWOUPV2;
        return xSellProducts.map((product,key) => {
            let productClickMetrics = twoUpVersion === 'noInstantInk'
                                    ? this.getLinkMetrics({ product, position: key+1 })
                                    : {};
            let ctaMetricProps = this.getCtaMetricProps();
            return(
                <XSellProductItem
                    isV2={isV2}
                    key={product.itemId}
                    product={product}
                    priceObj={Helpers.getProductPrice(product,this.props.prices)}
                    addProduct={this.addProduct}
                    removeProduct={this.removeProduct}
                    addedProducts={this.state.addedProducts}
                    disableRemove={disableRemove}
                    twoUpVersion={twoUpVersion}
                    setCarouselHeight={enableCarousel? () => setCarouselHeight(this.carousel.current) : null }
                    productClickMetrics={productClickMetrics}
                    {...ctaMetricProps}
                />
            )
        })
    }

    controls() {
        return {
            renderCenterLeftControls : NavArrow.PrevArrow,
            renderCenterRightControls: NavArrow.NextArrow,
            renderBottomCenterControls: () => <div></div>
        }
    }

    getLinkMetrics = ({product, position}) => {
        if(this.props.templateKey === 'pdp'){
            return getProductClickMetrics({ product, position, useAttributes: true, list: 'pdp-cross-sell' });
        }
        return null;
    }

    getCtaMetricProps = () => {
        let {templateKey, template, product} = this.props;
        let {sku} = product || {};
        let isPdp = templateKey === 'pdp';
        let ctaMetricProps = {};
        if(isPdp){
            ctaMetricProps = { 
                // baseProductSku and xsellType are used in ecommerce.add.products array in the data layer call
                baseProductSku: sku, 
                xsellType: template === XSELL_TEMPLATES.TWOUPV2
                            ? '2up-ink'
                            : 'tabs', // '3up-tabs' in click tracking
                // ctaMetrics is used on the detail.actionField.list
                ctaMetrics: { 
                    list: 'pdp-cross-sell'
                },
                getProductClickMetrics: this.getLinkMetrics
            }
        }

        return ctaMetricProps;
    }


    modalContent(xSellProds, template, twoUpVersion, isBundleTest, bundleData, productInfo, preAddedProducts, overwrites) {
        const { xSellProducts, templateKey, ...restProps } = this.props;
        const params = {
            product: this.props.product || {},
            carousel: this.carousel,
            crtUrl: this.props.crtUrl,
            closeModal: this.props.closeModal,
            proceed: this.proceed,
            setHTML: this.setHTML,
            xSellProductList: [],
            version: twoUpVersion,
            productInfo
        };

        let enableCarousel = false;
        let disableRemove = false;
        let ctaMetricProps = this.getCtaMetricProps();

        // render modal templates
        switch(template) {
            case XSELL_TEMPLATES.TWOUPV2: {
                params.xSellProductList = this.xSellProductList(xSellProds, enableCarousel, disableRemove, twoUpVersion);
                return <TwoUpV2 {...params} {...ctaMetricProps} prices={this.props.prices} />
            }
            case XSELL_TEMPLATES.PRECHECKED: {
                const {name} = this.props.product;
                params.xSellProductList = this.xSellProductList(xSellProds, enableCarousel, disableRemove, twoUpVersion);
                params.name = name;
                return <Prechecked {...params} ctaMetrics={ctaMetricProps.ctaMetrics}/>
            }
            case XSELL_TEMPLATES.TABS: {
                if (isBundleTest) {
                    return <TabsXsellBundleTestModal {...restProps} {...bundleData} {...ctaMetricProps} xSellProductList={xSellProds} />
                } else {
                    return <TabsXsellModal {...restProps} {...ctaMetricProps} xSellProductList={xSellProds} />;
                }
            }
            case XSELL_TEMPLATES.TABSV2: {
                return <TabsXsellModalV2 {...restProps} {...ctaMetricProps} preAddedProducts={preAddedProducts} overwrites={overwrites} />;
            }
            default: {
                if (isBundleTest) {
                    return <TabsXsellBundleTestModal {...restProps} {...bundleData} {...ctaMetricProps} xSellProductList={xSellProds}/>
                } else {
                    return <TabsXsellModal {...restProps} {...ctaMetricProps} xSellProductList={xSellProds} />;
                }
            }
        }
    }

    render() {
        let { template, limit = 25, xSellProducts, product={} } = this.props;
        let { xsell = [], productGroup} = xSellProducts || {};

        const { name, imageUrl, ksps, salePrice } = product;
        const productInfo = { name, imageUrl, ksps, salePrice };
        const isV2 = template === XSELL_TEMPLATES.TWOUPV2 || template === XSELL_TEMPLATES.TABSV2;

        let specialClass = '';
        let preAddedProducts;
        let overwrites;

        let xsellProds = productGroup && productGroup.active && productGroup.productsList && productGroup.productsList.length > 0 
                        ? productGroup.productsList 
                        : xsell;
        let twoUpVersion = 'noInstantInk';

        if (template === XSELL_TEMPLATES.TABS) {
            xSellProducts = productGroup && productGroup.metaData && productGroup.metaData.overwriteXsell ? xsellProds : xsell;
            specialClass = '-tabs-class';
        }

        if (template === XSELL_TEMPLATES.TABSV2) {
            specialClass = '-tabs-class';
            /*when overwriteXsell is present, set overwrites in tabsv2*/
            if (productGroup && productGroup.metaData && productGroup.metaData.overwriteXsell) {
                overwrites = productGroup.productsList && productGroup.productsList.length > 0 ? productGroup.productsList : null;
            } else {
                /*if productgroup is present, but overwriteXsell is not present, set preAddedProducts*/
                preAddedProducts = productGroup && productGroup.productsList && productGroup.productsList.length > 0? 
                productGroup.productsList.slice(0, 2).filter((product) => product.instock !== false) : 
                null;
            }
        }

        if (template === XSELL_TEMPLATES.PRECHECKED || template === XSELL_TEMPLATES.TWOUPV2) {
            xsellProds = productGroup.productsList;
            xSellProducts = (xsellProds || []).slice(0, limit);
            specialClass = '-no-instantink';
        }

        return (
            <ErrorBoundary>
                { template === XSELL_TEMPLATES.TABS || template === XSELL_TEMPLATES.TABSV2 ?
                    <ABTest experimentID="xsell-modal-bundle-test">
                        {
                            (data) => {
                                let bundleData;
                                let enabled;
                                const isProductPC = Helpers.isProductPC(product);
                                if (isProductPC) {
                                    bundleData = data.enabled ? data : null;
                                    enabled = data.enabled;
                                } else {
                                    enabled = false;
                                }
                                
                                return (
                                    <div className={`xsell-modal${specialClass}${isV2 ? ' v2' : ''}`}>
                                        { this.modalContent(xSellProducts, template, null, enabled, bundleData, null, preAddedProducts, overwrites) }
                                    </div>
                                )
                            }
                        }
                    </ABTest> :
                    <div className={`xsell-modal${isV2 ? '' : specialClass} xsell-modal-printer${isV2 ? ' v2' : ''}`}>
                        { isV2 ? this.modalContent(xSellProducts, template, twoUpVersion, false, null, productInfo) : this.modalContent(xSellProducts, template, twoUpVersion) }
                    </div>
                }
            </ErrorBoundary>
        )
    }
};

const mapStateToProps = (state) => ({
    blocked: state.xSell.blocked,
    prices: state.productData.productInfo.productPrices,
    crtUrl: state.cartInfo.crtUrl
});

const mapDispatchToProps = dispatch => {
    return {
        addToCart: (product, quantity, blockFlyout, options, baseProductSku, xsellTemplate, ctaMetrics) => dispatch(addMultipleToCart(product, quantity, blockFlyout, options, baseProductSku, xsellTemplate, ctaMetrics))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withError(XSellModal));